import {
  DO_IMPORT_CUSTOMER,
  SHOW_MODAL_IMPORT,
  SHOW_MODAL_ERROR_IMPORT,
  SET_IMPORTING_STATUS,
  DO_IMPORT_ITEM,
} from './constants';

// export function for import csv
export function doImportCustomer(file, hasLoyalty) {
  return { type: DO_IMPORT_CUSTOMER, payload: { file, hasLoyalty } };
}

export function doImportItem(file, importType) {
  return { type: DO_IMPORT_ITEM, payload: { file, importType } };
}

export function showModalImport(showModalImport) {
  return { type: SHOW_MODAL_IMPORT, payload: { showModalImport } };
}

export function showModalErrorImport(status, message) {
  return {
    type: SHOW_MODAL_ERROR_IMPORT,
    payload: { showModalErrorImport: status, messageError: message },
  };
}

export function setImportingStatus(status) {
  return { type: SET_IMPORTING_STATUS, payload: { importingStatus: status } };
}
